<template>
  <div class="dropdown" :class="{ 'is-active': isOpen, 'is-disabled': disabled }">
    <div class="dropdown-trigger" @click="toggleOpen" v-click-away="close">
      <slot v-if="dropDownIcon === 'none'" name="trigger"></slot>
      <a class="dropdown-colours" :class="{ active: isOpen, 'use-colour': useColourOnActive }" v-else>
        <AddIcon v-if="dropDownIcon === 'big-add-circle'" title="" class="big-add-circle icon-3x"></AddIcon>
        <Dots v-if="dropDownIcon === 'dots'" class="dots icon-1-5x"></Dots>
        <CodeIcon v-if="dropDownIcon === 'variable'" class="icon-1-2x" :class="{ clicked: isOpen }"></CodeIcon>
      </a>
    </div>
    <div class="dropdown-menu" :class="{ 'go-left': goLeft }" id="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, nextTick } from 'vue';
import { dropDownHelper } from './dropDownHelper';
import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
import CodeIcon from 'vue-material-design-icons/CodeBrackets.vue';
import Dots from 'vue-material-design-icons/DotsVertical.vue';

const props = defineProps({
  goLeft: {
    type: Boolean,
    default: false,
  },
  dropDownIcon: {
    type: String,
    default: 'dots',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  useColourOnActive: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits<{
  (e: 'isUp', value: boolean): void;
  (e: 'open', value: boolean): void;
}>();

const isOpen = ref(false);
const isUp = ref(false);

function toggleOpen() {
  if (props.disabled) {
    return;
  }

  isOpen.value = !isOpen.value;
  refresh();
}

function close() {
  isOpen.value = false;
  refresh();
}

function refresh() {
  nextTick(() => {
    isUp.value = dropDownHelper.isDropDownUp();
    emit('isUp', isUp.value);
    emit('open', isOpen.value);
  });
}
</script>
<style scoped lang="scss">
.clicked {
  color: rgba(10, 10, 10, 0.8);
}

.icon {
  color: #a9a9a9;
}

.go-left {
  left: auto;
  right: 0;
}

.dropdown-colours {
  color: rgba(10, 10, 10, 0.4);
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: rgba(10, 10, 10, 0.8);
    cursor: pointer;
  }

  &.use-colour {
    padding: 0.5rem;
    .dots {
      color: $tertiary;
      .material-design-icon__svg {
        bottom: 0;
      }
    }
    &:hover,
    &.active {
      background: $tertiary;
      .dots {
        color: $primary;
      }
    }
  }
}

.big-add-circle {
  color: #ff6666;
  &:hover {
    color: #fd8384;
  }
}

.dots {
  color: #a9a9a9;

  &:hover {
    color: #cecece;
  }
}
</style>
